import { actions as actions$1, Locales, useFeatureToggles, SagaRegistry } from '@grandvisionhq/state';
import Cookie from 'js-cookie';
import { parseVisitorId, isArray, getAttrValue, isPlainObject, getLocalizedValue, getLocalizedValues, getLocalizedAttrValue, getJoinedLocalizedAttrValues, StringUtils, formatHour, getNestedProperty, getFrontImage, QueryString, StringGuard, optionalKey, useLocalStorage } from '@grandvisionhq/utils';
import * as swcHelpers from '@swc/helpers';
import { useInView } from 'react-intersection-observer';
import { takeLatest, call, all } from 'redux-saga/effects';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import * as React from 'react';
import React__default from 'react';
import ReactGA from 'react-ga';
import gtmParts from 'react-google-tag-manager';
import { connectStateResults } from 'react-instantsearch-core';
import { useCookieConsentContext, isCookieCategoryEnabled } from '@grandvisionhq/cookie-consent';

var AlgoliaAnalyticsEvents;
(function(AlgoliaAnalyticsEvents) {
    AlgoliaAnalyticsEvents["SearchSuggestionClicked"] = 'Search Suggestion Clicked';
    AlgoliaAnalyticsEvents["SearchResultClicked"] = 'Search Result Clicked';
    AlgoliaAnalyticsEvents["ProductDetailCTAClicked"] = 'Product Detail CTA Clicked';
})(AlgoliaAnalyticsEvents || (AlgoliaAnalyticsEvents = {}));
var AlgoliaEventType;
(function(AlgoliaEventType) {
    AlgoliaEventType["Conversion"] = 'convertedObjectIDs';
    AlgoliaEventType["ConversionAfterSearch"] = 'convertedObjectIDsAfterSearch';
    AlgoliaEventType["Click"] = 'clickedObjectIDs';
    AlgoliaEventType["ClickAfterSearch"] = 'clickedObjectIDsAfterSearch';
})(AlgoliaEventType || (AlgoliaEventType = {}));

var types$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AlgoliaAnalyticsEvents () { return AlgoliaAnalyticsEvents; },
  get AlgoliaEventType () { return AlgoliaEventType; }
});

const getVisitorId = ()=>{
    const visitorCookie = Cookie.get('_visitor');
    if (!visitorCookie) {
        return Cookie.get('_ALGOLIA') // use the fallback user token provided by algolia
        ;
    }
    const visitorId = parseVisitorId(visitorCookie);
    if (visitorId !== undefined && typeof visitorId !== 'string') {
        return visitorId.id;
    }
    return visitorId;
};
const clickedObjectIds = (eventData)=>{
    const algoliaAnalyticsHandler = getAlgoliaAnalyticsHandler();
    const { objectIds , searchIndex , eventName  } = eventData;
    if (algoliaAnalyticsHandler) {
        algoliaAnalyticsHandler(AlgoliaEventType.Click, {
            userToken: getVisitorId(),
            objectIDs: isArray(objectIds) ? objectIds : [
                objectIds
            ],
            index: searchIndex,
            eventName
        });
    }
};
const handleConversionEvent = (eventData)=>{
    const algoliaAnalyticsHandler = getAlgoliaAnalyticsHandler();
    const { objectIds , searchIndex , queryId  } = eventData;
    const visitorId = getVisitorId();
    if (!visitorId) {
        return;
    }
    if (algoliaAnalyticsHandler && searchIndex && objectIds) {
        const eventData = {
            userToken: visitorId,
            index: searchIndex,
            queryID: queryId,
            eventName: AlgoliaAnalyticsEvents.ProductDetailCTAClicked,
            objectIDs: Array.isArray(objectIds) ? objectIds : [
                objectIds
            ]
        };
        const type = eventData.queryID ? AlgoliaEventType.ConversionAfterSearch : AlgoliaEventType.Conversion;
        algoliaAnalyticsHandler(type, eventData);
    }
};
const clickedObjectIdsAfterSearch = (eventData)=>{
    const algoliaAnalyticsHandler = getAlgoliaAnalyticsHandler();
    const { searchIndex , positions , objectIds , eventName , queryId  } = eventData;
    if (!positions || !objectIds) {
        console.warn('Algolia analytics event could not be sent! eventData:', eventData);
        return;
    }
    if (algoliaAnalyticsHandler) {
        algoliaAnalyticsHandler(AlgoliaEventType.ClickAfterSearch, {
            eventName,
            queryID: queryId,
            objectIDs: isArray(objectIds) ? objectIds : [
                objectIds
            ],
            positions: isArray(positions) ? positions : [
                positions
            ],
            index: searchIndex,
            userToken: getVisitorId()
        });
    }
};
const getAlgoliaAnalyticsHandler = ()=>{
    if (typeof window !== undefined && window.aa) {
        return window.aa;
    }
    return undefined;
};

var AlgoliaAnalyticsHelpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getVisitorId: getVisitorId,
  clickedObjectIds: clickedObjectIds,
  handleConversionEvent: handleConversionEvent,
  clickedObjectIdsAfterSearch: clickedObjectIdsAfterSearch,
  getAlgoliaAnalyticsHandler: getAlgoliaAnalyticsHandler
});

const pushEvent$1 = actions$1.action('analytics/data-layer/push-event', function(payload) {
    return {
        payload
    };
});

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pushEvent: pushEvent$1
});

var Category;
(function(Category) {
    Category["ContactLenses"] = 'Contact-Lenses';
    Category["Sunglasses"] = "Sunglasses";
    Category["Optical"] = "Optical";
    Category["Accessories"] = "Accessories";
    Category["Solutions"] = "Solutions";
    Category["ReadyReaders"] = 'Ready-readers';
})(Category || (Category = {}));
var LineItemType;
(function(LineItemType) {
    LineItemType["Single"] = 'single';
    LineItemType["Bundle"] = 'bundle';
})(LineItemType || (LineItemType = {}));
var PurchaseType;
(function(PurchaseType) {
    PurchaseType["Subscription"] = 'subscription';
    PurchaseType["OneTime"] = 'one-time';
})(PurchaseType || (PurchaseType = {}));
var EventType;
(function(EventType) {
    EventType["add"] = "add";
    EventType["remove"] = "remove";
    EventType["checkout"] = "checkout";
    EventType["purchase"] = "purchase";
})(EventType || (EventType = {}));

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get Category () { return Category; },
  get LineItemType () { return LineItemType; },
  get PurchaseType () { return PurchaseType; },
  get EventType () { return EventType; }
});

const getUrlInfo = (lineItem)=>{
    var ref1;
    const { productType , productSlug , variant: { sku  } ,  } = lineItem;
    const productTypeName = ((ref1 = productType.obj) === null || ref1 === void 0 ? void 0 : ref1.name) || '';
    return {
        productType: productTypeName || '',
        slug: productSlug || '',
        sku: sku || ''
    };
};
const getPaymentMethodUrl = (paymentMethod)=>{
    switch(paymentMethod){
        case 'creditcard':
            return 'http://purl.org/goodrelations/v1#CreditCard';
        case 'paypal':
            return 'http://purl.org/goodrelations/v1#PayPal';
        default:
            return '';
    }
};
const priceVatCalc = (price, rate)=>{
    const priceExVat = price / (1 + rate);
    const vatAmount = priceExVat * rate;
    return {
        priceExVat,
        vatAmount
    };
};
const calcPrice = (centAmount)=>{
    const price = !isNaN(centAmount) ? (centAmount / 100).toFixed(2).toString() : '0.00';
    if (price === '0') {
        return '0.00';
    }
    return price;
};
const createOfferObject = (lineItem, quantity)=>{
    var ref3;
    const activeVariant = lineItem.variant;
    var ref2;
    const vat = (ref2 = lineItem === null || lineItem === void 0 ? void 0 : (ref3 = lineItem.taxRate) === null || ref3 === void 0 ? void 0 : ref3.amount) !== null && ref2 !== void 0 ? ref2 : 0;
    return {
        '@type': 'Offer',
        includesObject: {
            '@type': 'TypeAndQuantityNode',
            amountOfThisGood: quantity || 1
        },
        priceSpecification: createPriceSpecification(activeVariant, vat)
    };
};
const convertAttributeToLowerCase = (attribute)=>{
    return Array.isArray(attribute) ? attribute.join().toLowerCase() : attribute.toLowerCase();
};
const createProductObject = (lineItem, quantity, formatProductUrl, selfUrl)=>{
    const urlInfo = getUrlInfo(lineItem);
    let url = selfUrl || window.location && window.location.origin || '';
    if (formatProductUrl && urlInfo) {
        url += formatProductUrl(urlInfo);
    }
    const { variant , productId , name  } = lineItem;
    const modelObj = getAttrValue(variant, 'frameShape');
    const model = isPlainObject(modelObj) ? getLocalizedValue(modelObj, 'en') : '';
    const frameMaterialAttr = getAttrValue(variant, 'frameMaterial');
    const frameMaterial = isPlainObject(frameMaterialAttr) ? getLocalizedValue(frameMaterialAttr, 'en') : '';
    const frameMaterials = Array.isArray(frameMaterialAttr) ? getLocalizedValues(frameMaterialAttr, 'en') : '';
    const frameColorAttr = getAttrValue(variant, 'frameColor');
    const frameColor = isPlainObject(frameColorAttr) ? getLocalizedValue(frameColorAttr, 'en') : '';
    const frameColors = isArray(frameColorAttr) ? getLocalizedValues(frameColorAttr, 'en') : '';
    return {
        '@type': 'Product',
        '@id': `${url}#product`,
        url,
        model,
        name: name.en || '',
        productID: productId || '',
        gtin13: variant.sku || urlInfo.sku || '',
        category: urlInfo.productType || '',
        brand: String(getAttrValue(variant, 'brand')),
        material: convertAttributeToLowerCase(frameMaterials || frameMaterial),
        color: convertAttributeToLowerCase(frameColor || frameColors),
        offers: [
            createOfferObject(lineItem, quantity)
        ]
    };
};
const createPrescriptionGlassesObject = (lineItem, formatProductUrl, selfUrl)=>{
    const { name , productId , brand , variant , productType , slug  } = lineItem.bundleMainLineItem;
    let url = selfUrl || window.location && window.location.origin || '';
    if (formatProductUrl) {
        url += formatProductUrl({
            sku: variant.sku,
            productType: productType,
            slug
        });
    }
    return {
        '@type': 'Product',
        '@id': `${url}#product`,
        url,
        brand,
        name: name.en || '',
        sku: variant.sku || '',
        gtin13: variant.sku || '',
        productID: productId || '',
        category: 'Optical',
        offers: [
            createPrescriptionGlassesOffer(lineItem)
        ]
    };
};
const createPrescriptionGlassesOffer = ({ quantity , price , bundleMainLineItem  })=>({
        '@type': 'Offer',
        includesObject: {
            '@type': 'TypeAndQuantityNode',
            amountOfThisGood: quantity || 1
        },
        priceSpecification: createPrescriptionGlassesPrice(price, bundleMainLineItem.taxRate)
    })
;
const createPrescriptionGlassesPrice = (price, taxRate)=>{
    var ref4;
    var _centAmount;
    const resolvedPrice = (_centAmount = (ref4 = price.discounted) === null || ref4 === void 0 ? void 0 : ref4.value.centAmount) !== null && _centAmount !== void 0 ? _centAmount : price.value.centAmount;
    const resolvedPriceExVat = resolvedPrice * (1 - taxRate.amount);
    const resolvedVatAmount = resolvedPrice * taxRate.amount;
    return {
        '@type': 'CompoundPriceSpecification',
        name: 'Price',
        price: calcPrice(resolvedPrice),
        priceCurrency: price.value.currencyCode,
        valueAddedTaxIncluded: true,
        priceComponent: [
            {
                '@type': 'UnitPriceSpecification',
                name: 'Price excluding VAT',
                price: calcPrice(resolvedPriceExVat),
                valueAddedTaxIncluded: false
            },
            {
                '@type': 'UnitPriceSpecification',
                name: 'VAT',
                price: calcPrice(resolvedVatAmount),
                valueAddedTaxIncluded: true
            }, 
        ]
    };
};
const createOrderObject = (order, paymentMethod, formatProductUrl, selfUrl)=>{
    const { lineItems , prescriptionGlassesLineItems =[] , orderNumber , totalPrice , shippingInfo ,  } = order;
    const originalTotal = [
        ...lineItems,
        ...prescriptionGlassesLineItems
    ].reduce((total, currentValue)=>total += currentValue.price.value.centAmount * currentValue.quantity
    , 0);
    const shippingCost = shippingInfo && shippingInfo.price ? shippingInfo.price.centAmount : 0;
    const discountTotal = originalTotal - totalPrice.centAmount + shippingCost;
    const orderedItems = lineItems && lineItems.map((lineItem)=>createProductObject(lineItem, lineItem.quantity, formatProductUrl, selfUrl)
    );
    const orderedPGItems = prescriptionGlassesLineItems.map((pgItem)=>createPrescriptionGlassesObject(pgItem, formatProductUrl, selfUrl)
    );
    return {
        '@type': 'Order',
        discount: calcPrice(discountTotal),
        orderNumber: orderNumber || '',
        orderTotal: calcPrice(originalTotal),
        shipmentCost: calcPrice(shippingCost),
        orderedItem: [
            ...orderedItems,
            ...orderedPGItems
        ] || [],
        paymentMethod: getPaymentMethodUrl(paymentMethod || '')
    };
};
/**
 * Sets a new Action Object on the global SD actions storage on window
 */ const pushSdAction = (action)=>{
    if (typeof window === 'undefined') {
        return;
    }
    if (!window.grandvision || !Array.isArray(window.grandvision.actions)) {
        window.grandvision = {
            actions: []
        };
    }
    window.grandvision.actions.push(action);
    if (process.env.NODE_ENV !== 'production') {
        console.log('New Structured Data Action pushed to window.grandvision.actions: ', action);
    }
};
const getFacetLabel = (key, facetLabels)=>{
    const labelObject = facetLabels.find((facetLabel)=>facetLabel.value === key
    );
    return labelObject ? labelObject.label : '';
};
const FACET_BLACKLIST = [
    'variants',
    'attributes',
    'label',
    'centAmount'
];
const getSanitizedFacetName = (facet, locale)=>{
    return facet.split('.').filter((key)=>!(key === locale || FACET_BLACKLIST.includes(key))
    ).join('');
};
var ref;
const getIncludedVatAmount = (product)=>{
    var ref7, ref5, ref6;
    return (ref6 = ((ref = product === null || product === void 0 ? void 0 : (ref7 = product.taxCategory) === null || ref7 === void 0 ? void 0 : (ref5 = ref7.obj) === null || ref5 === void 0 ? void 0 : ref5.rates) !== null && ref !== void 0 ? ref : []).find((rate)=>rate.includedInPrice
    )) === null || ref6 === void 0 ? void 0 : ref6.amount;
};
function createPriceSpecification(variant, vat) {
    var ref14;
    if (!variant) {
        console.warn('No variant data found.');
        return null;
    }
    if (typeof vat === 'undefined') {
        console.warn(`No VAT amount found for variant with SKU ${variant.sku}.`);
        return null;
    }
    var _prices;
    const pricing = ((_prices = variant.prices) !== null && _prices !== void 0 ? _prices : []).find((price)=>typeof price.value.centAmount !== 'undefined'
    );
    if (!pricing) {
        console.warn(`Variant with SKU ${variant.sku} doesn't have any pricing.`);
        return null;
    }
    const regularPrice = pricing.value.centAmount;
    var _centAmount;
    const discountedPrice = (_centAmount = (ref14 = pricing.discounted) === null || ref14 === void 0 ? void 0 : ref14.value.centAmount) !== null && _centAmount !== void 0 ? _centAmount : 0;
    const currency = pricing.value.currencyCode;
    const vatRate = vat ? vat : 0;
    let priceSpecification = null;
    if (!regularPrice) {
        console.warn(`Regular price is 0 on variant with SKU ${variant.sku}.`);
    } else if (vatRate === 0) {
        console.warn(`VAT rate is 0 on variant with SKU ${variant.sku}.`);
    } else {
        const { priceExVat , vatAmount  } = priceVatCalc(regularPrice, vatRate);
        if (!priceExVat || !vatAmount) {
            console.warn(`Missing \'priceExVat\' or \'vatAmount\'`);
            return null;
        }
        const regularPriceSpecification = {
            '@type': 'CompoundPriceSpecification',
            name: 'Price',
            price: calcPrice(regularPrice),
            priceCurrency: currency,
            valueAddedTaxIncluded: true,
            priceComponent: [
                {
                    '@type': 'UnitPriceSpecification',
                    name: 'Price excluding VAT',
                    price: calcPrice(priceExVat),
                    valueAddedTaxIncluded: false
                },
                {
                    '@type': 'UnitPriceSpecification',
                    name: 'VAT',
                    price: calcPrice(vatAmount),
                    valueAddedTaxIncluded: true
                }, 
            ]
        };
        priceSpecification = regularPriceSpecification;
        if (discountedPrice) {
            var ref8, ref9, ref10, ref11, ref12, ref13;
            const { priceExVat: discountedPriceExVat , vatAmount: discountedVatAmount  } = priceVatCalc(discountedPrice, vatRate);
            const validFrom = (ref8 = pricing.discounted) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.discount) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.obj) === null || ref10 === void 0 ? void 0 : ref10.validFrom;
            const validThrough = (ref11 = pricing.discounted) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.discount) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.obj) === null || ref13 === void 0 ? void 0 : ref13.validUntil;
            const discountPriceSpecification = {
                '@type': 'CompoundPriceSpecification',
                name: 'Price',
                priceCurrency: currency,
                price: calcPrice(discountedPrice),
                valueAddedTaxIncluded: true,
                validFrom,
                validThrough,
                priceComponent: [
                    {
                        '@type': 'UnitPriceSpecification',
                        name: 'Price excluding VAT',
                        price: calcPrice(discountedPriceExVat),
                        valueAddedTaxIncluded: false
                    },
                    {
                        '@type': 'UnitPriceSpecification',
                        name: 'VAT',
                        price: calcPrice(discountedVatAmount),
                        valueAddedTaxIncluded: true
                    }, 
                ]
            };
            priceSpecification = discountPriceSpecification;
        }
    }
    return priceSpecification;
}

const getNameFromVariant = (variant)=>{
    const brand = getAttrValue(variant, 'brand');
    const brandModel = getAttrValue(variant, 'brandModel');
    const brandModelCode = getAttrValue(variant, 'brandModelCode');
    const name = [
        ...new Set([
            brand,
            brandModel,
            brandModelCode
        ].filter(Boolean))
    ].join(' ').trim();
    return name;
};
const getPrices = (lineItem)=>{
    var ref, ref1;
    const variant = 'variant' in lineItem ? lineItem.variant : lineItem.bundleMainLineItem.variant;
    const vat = 'variant' in lineItem ? (ref = lineItem.taxRate) === null || ref === void 0 ? void 0 : ref.amount : lineItem.bundleMainLineItem.taxRate.amount;
    let pricing;
    if (!variant) {
        console.warn('No variant data found.');
        return null;
    }
    if (typeof vat === 'undefined') {
        console.warn(`No VAT amount found for variant with SKU ${variant.sku}.`);
        return null;
    }
    if ('variant' in lineItem) {
        var _prices;
        pricing = ((_prices = variant.prices) !== null && _prices !== void 0 ? _prices : []).find((price)=>typeof price.value.centAmount !== 'undefined'
        );
    } else {
        pricing = lineItem.price;
    }
    if (!pricing) {
        console.warn(`Variant with SKU ${variant.sku} doesn't have any pricing.`);
        return null;
    }
    const regularPrice = pricing.value.centAmount;
    var _centAmount;
    const discountedPrice = (_centAmount = (ref1 = pricing.discounted) === null || ref1 === void 0 ? void 0 : ref1.value.centAmount) !== null && _centAmount !== void 0 ? _centAmount : null;
    const discountAmount = discountedPrice !== null ? regularPrice - discountedPrice : 0;
    const { vatAmount  } = discountedPrice !== null ? priceVatCalc(discountedPrice, vat) : priceVatCalc(regularPrice, vat);
    return {
        original: calcPrice(regularPrice),
        discountedPrice: discountedPrice !== null ? calcPrice(discountedPrice) : calcPrice(regularPrice),
        discountAmount: calcPrice(discountAmount),
        vatAmount: calcPrice(vatAmount)
    };
};
const getSharedAttributes = (lineItem, lineItemType, locale, purchaseType)=>{
    const prices = getPrices(lineItem);
    const isBundleLineItem = 'variant' in lineItem;
    const sku = isBundleLineItem ? lineItem.variant.sku : lineItem.bundleMainLineItem.variant.sku;
    const name = isBundleLineItem ? getNameFromVariant(lineItem.variant) : '';
    return {
        name,
        id: sku || '',
        price: (prices === null || prices === void 0 ? void 0 : prices.discountedPrice) || '',
        dimension143: purchaseType ? purchaseType : PurchaseType.OneTime,
        dimension144: lineItemType,
        dimension145: 'true',
        metric140: (prices === null || prices === void 0 ? void 0 : prices.original) || '',
        metric141: (prices === null || prices === void 0 ? void 0 : prices.discountAmount) || '',
        metric142: (prices === null || prices === void 0 ? void 0 : prices.vatAmount) || '',
        quantity: lineItem.quantity
    };
};
const getSunglassesAttributes = (lineItem, locale)=>{
    const sharedAttributes = getSharedAttributes(lineItem, LineItemType.Single);
    const variant = lineItem.variant || [];
    const brand = getAttrValue(variant, 'brand') || '';
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: Category.Sunglasses,
        brand,
        variant: getLocalizedAttrValue(variant, 'frameShape', locale).toLowerCase(),
        dimension16: getJoinedLocalizedAttrValues(variant, 'gender', locale).toLowerCase(),
        dimension146: getLocalizedAttrValue(variant, 'frameMaterial', locale).toLowerCase(),
        dimension147: getLocalizedAttrValue(variant, 'frameColor', locale).toLowerCase(),
        dimension140: variant.sku || ''
    });
};
const getReadyReadersAttributes = (lineItem, locale)=>{
    const sharedAttributes = getSharedAttributes(lineItem, LineItemType.Single);
    const variant = lineItem.variant || [];
    const brand = getAttrValue(variant, 'brand') || '';
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: getNameFromVariant(lineItem.variant),
        category: Category.ReadyReaders,
        brand,
        variant: getLocalizedAttrValue(variant, 'frameShape', locale).toLowerCase(),
        dimension16: getJoinedLocalizedAttrValues(variant, 'gender', locale).toLowerCase(),
        dimension146: getLocalizedAttrValue(variant, 'frameMaterial', locale).toLowerCase(),
        dimension147: getLocalizedAttrValue(variant, 'frameColor', locale).toLowerCase()
    });
};
const getAccessoriesAttributes = (lineItem, locale)=>{
    const sharedAttributes = getSharedAttributes(lineItem, LineItemType.Single);
    const variant = lineItem.variant || [];
    const brand = getAttrValue(variant, 'brand') || '';
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: getNameFromVariant(lineItem.variant),
        category: Category.Accessories,
        brand,
        variant: getLocalizedAttrValue(variant, 'accessoryType', locale).toLowerCase(),
        dimension16: getJoinedLocalizedAttrValues(variant, 'gender', locale).toLowerCase(),
        dimension146: getLocalizedAttrValue(variant, 'material', locale).toLowerCase(),
        dimension147: getJoinedLocalizedAttrValues(variant, 'accessoryColor', locale).toLowerCase(),
        dimension140: variant.sku || ''
    });
};
const getContactLensesAttributes = (lineItem, locale)=>{
    const variant = lineItem.variant;
    const sharedAttributes = getSharedAttributes(lineItem, LineItemType.Single);
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: getLocalizedValue(lineItem.name, locale),
        brand: getAttrValue(variant, 'brand') || '',
        category: Category.ContactLenses,
        variant: getLocalizedAttrValue(variant, 'lensType', locale),
        dimension148: getLocalizedAttrValue(variant, 'replacementFrequency', locale),
        dimension146: getJoinedLocalizedAttrValues(variant, 'material', locale),
        dimension140: variant.sku || ''
    });
};
const getPrescriptionGlassesAttributes = (lineItem, locale)=>{
    const sharedAttributes = getSharedAttributes(lineItem, LineItemType.Bundle);
    const category = lineItem.bundleMainLineItem.productType === 'sunglasses' ? Category.Sunglasses : Category.Optical;
    const { variant , brand , brandModel , brandModelCode  } = lineItem.bundleMainLineItem;
    const name = [
        ...new Set([
            brand,
            brandModel,
            brandModelCode
        ].filter(Boolean))
    ].join(' ');
    const frameMaterial = getJoinedLocalizedAttrValues(variant, 'frameMaterial', locale).toLowerCase();
    const frameColor = getJoinedLocalizedAttrValues(variant, 'frameColor', locale).toLowerCase();
    const frameShape = getJoinedLocalizedAttrValues(variant, 'frameShape', locale).toLowerCase();
    const gender = getJoinedLocalizedAttrValues(variant, 'gender', locale).toLowerCase();
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name,
        brand: lineItem.bundleMainLineItem.brand || '',
        category,
        variant: frameShape,
        dimension140: variant.sku || ''
    }, frameMaterial ? {
        dimension146: frameMaterial
    } : null, frameColor ? {
        dimension147: frameColor
    } : null, gender ? {
        dimension16: gender
    } : null);
};
const getSolutionsAttributes = (lineItem, locale)=>{
    const sharedAttributes = getSharedAttributes(lineItem, LineItemType.Single);
    const brand = getAttrValue(lineItem.variant, 'brand') ? String(getAttrValue(lineItem.variant, 'brand')) : '';
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: getLocalizedValue(lineItem.name, locale),
        category: Category.Solutions,
        brand,
        variant: 'solution'
    });
};
const getContactLensesBundleBeneluxAttributes = (lineItem, locale)=>{
    const sharedAttributes = getSharedAttributes(lineItem, LineItemType.Bundle, locale, PurchaseType.Subscription);
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: getLocalizedValue(lineItem.name, locale),
        category: Category.ContactLenses,
        variant: getLocalizedAttrValue(lineItem.variant, 'lensType', locale)
    });
};
const mapLineItemToDataLayerProductObjects = (lineItems, prescriptionGlassesLineItems)=>{
    // Data in the Data Layer should always be English, therefore hardcoded locale
    const locale = Locales['en-GB'];
    let productObjects = [];
    if (lineItems) {
        productObjects = lineItems.map((lineItem)=>{
            var ref, ref2, ref3, ref4, ref5, ref6;
            if (((ref = lineItem.productType.obj) === null || ref === void 0 ? void 0 : ref.name) === 'Sunglasses') {
                return getSunglassesAttributes(lineItem, locale);
            }
            if (((ref2 = lineItem.productType.obj) === null || ref2 === void 0 ? void 0 : ref2.name) === 'Contact-lenses') {
                return getContactLensesAttributes(lineItem, locale);
            }
            if (((ref3 = lineItem.productType.obj) === null || ref3 === void 0 ? void 0 : ref3.name) === 'Solutions') {
                return getSolutionsAttributes(lineItem, locale);
            }
            if (((ref4 = lineItem.productType.obj) === null || ref4 === void 0 ? void 0 : ref4.name) === 'Contact-lens-bundles') {
                return getContactLensesBundleBeneluxAttributes(lineItem, locale);
            }
            if (((ref5 = lineItem.productType.obj) === null || ref5 === void 0 ? void 0 : ref5.name) === 'Ready-readers') {
                return getReadyReadersAttributes(lineItem, locale);
            }
            if (((ref6 = lineItem.productType.obj) === null || ref6 === void 0 ? void 0 : ref6.name) === 'Accessories') {
                return getAccessoriesAttributes(lineItem, locale);
            }
        }).filter((product)=>product !== undefined
        );
    }
    if (prescriptionGlassesLineItems) {
        prescriptionGlassesLineItems.forEach((lineItem)=>{
            productObjects.push(getPrescriptionGlassesAttributes(lineItem, locale));
        });
    }
    return productObjects;
};

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getNameFromVariant: getNameFromVariant,
  getPrices: getPrices,
  mapLineItemToDataLayerProductObjects: mapLineItemToDataLayerProductObjects
});

function pushEvent(event) {
    if (typeof window === 'undefined') {
        return;
    }
    if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
    }
    window.dataLayer.push(event);
}
function pushEcommerceEvent(event) {
    // Make sure we clear the previous ecommerce object
    pushEvent({
        event: '',
        atfEcommerce: null
    });
    pushEvent(event);
}

function formatTime(time) {
    return typeof time === 'number' ? formatHour(time) : time;
}
const getOpeningHours = (store)=>{
    var _openingHours;
    const storeOpeningHours = swcHelpers.objectSpread({}, (_openingHours = store.openingHours) !== null && _openingHours !== void 0 ? _openingHours : {
        monday: store.mondayOpenClose,
        tuesday: store.tuesdayOpenClose,
        wednesday: store.wednesdayOpenClose,
        thursday: store.thursdayOpenClose,
        friday: store.fridayOpenClose,
        saturday: store.saturdayOpenClose,
        sunday: store.sundayOpenClose
    });
    return Object.entries(storeOpeningHours).filter(([, hours])=>hours && hours.length
    ).map(([day, hours])=>{
        const dayOfWeek = `https://schema.org/${StringUtils.upFirst(day)}`;
        return hours.map(({ open , close  })=>({
                '@type': 'OpeningHoursSpecification',
                closes: formatTime(close),
                dayOfWeek,
                opens: formatTime(open)
            })
        );
    }).flat();
};

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const DAY_NAMES = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
const getDayName = (date)=>{
    let day;
    const dayOfWeek = new Date(date).getDay() - 1;
    if (dayOfWeek < 0) {
        day = DAY_NAMES[DAY_NAMES.length - 1];
    } else {
        day = DAY_NAMES[dayOfWeek];
    }
    return `https://schema.org/${StringUtils.upFirst(day)}`;
};
const getSpecialOpeningHours = (specialOpeningHours)=>{
    let i1 = 0;
    return [
        ...specialOpeningHours
    ].sort((a, b)=>Date.parse(a.dateOpenClosed) - Date.parse(b.dateOpenClosed)
    ).reduce((acc, item)=>{
        const current = acc[i1];
        const a = current ? Date.parse(current[current.length - 1].dateOpenClosed) : 0;
        const b = Date.parse(item.dateOpenClosed);
        // if the item is not on a consecutive day to the previous item, put it in a new array.
        if (current && b - a > DAY_IN_MS) {
            i1++;
        }
        // if the item's openClosed is not the same as the previous item or any of
        // the openClosedTime entries differs from the previous item, put it in a new array.
        if (current && current.length > 0) {
            if (current[0].openClosed !== item.openClosed) {
                i1++;
            } else if (current[0].openClosedTime && item.openClosedTime) {
                const sameOpenClosedTime = current[0].openClosedTime.every((time, i)=>{
                    if (!item.openClosedTime || !item.openClosedTime[i]) {
                        return false;
                    }
                    return time.open === item.openClosedTime[i].open && time.close === item.openClosedTime[i].close;
                });
                if (!sameOpenClosedTime) {
                    i1++;
                }
            }
        }
        if (!acc[i1]) {
            acc[i1] = [];
        }
        acc[i1].push(item);
        return acc;
    }, []).reduce((acc, period)=>{
        const first = period[0];
        const last = period[period.length - 1];
        const dayOfWeek = period.length > 1 ? period.map((day)=>getDayName(day.dateOpenClosed)
        ) : getDayName(first.dateOpenClosed);
        let opens = '00:00';
        let closes = '00:00';
        if (first.openClosed === 'OPEN' && first.openClosedTime) {
            opens = first.openClosedTime[0].open;
            closes = first.openClosedTime[0].close;
        }
        acc.push({
            '@type': 'OpeningHoursSpecification',
            dayOfWeek,
            opens,
            closes,
            validFrom: first.dateOpenClosed,
            validThrough: last.dateOpenClosed
        });
        return acc;
    }, []);
};

const getOpeningHoursSpecification = (store)=>{
    var _specialOpeningHours;
    return [
        ...getOpeningHours(store),
        ...getSpecialOpeningHours((_specialOpeningHours = store.specialOpeningHours) !== null && _specialOpeningHours !== void 0 ? _specialOpeningHours : [])
    ];
};

const getServices = (facilities)=>({
        '@type': 'OfferCatalog',
        name: 'Services',
        itemListElement: facilities.map((facility)=>({
                '@type': 'Offer',
                itemOffered: {
                    '@type': 'Service',
                    name: facility
                }
            })
        )
    })
;

/**
 * Gets page name and transform it to the required pageType format
 */ const getPageType = (name)=>{
    const pageType = name.replace(/-/g, ' ');
    const plpPlaceholder = 'standard page';
    const pdpPlaceholder = 'product detail page';
    if (pageType.includes(pdpPlaceholder)) {
        return pageType.replace(pdpPlaceholder, 'PDP');
    } else if (pageType.includes(plpPlaceholder)) {
        return pageType.replace(plpPlaceholder, 'PLP');
    }
    return pageType;
};

const parseProductData = (product, activeVariant, staticsUrl, locale, isBynderImagesEnabled)=>{
    const image = getProductImageUrl(activeVariant, staticsUrl, isBynderImagesEnabled);
    const name = product.name.en || getAttrValue(activeVariant, 'brandModelCode');
    const description = getLocalizedAttrValue(activeVariant, 'description', locale);
    const brand = getAttrValue(activeVariant, 'brand');
    const firstCategory = getNestedProperty(product, 'categories')[0] || '';
    const category = getNestedProperty(firstCategory, `obj.name.en`, '');
    const sku = activeVariant.sku || '';
    return {
        name,
        image,
        description,
        brand,
        category,
        sku
    };
};
function getProductImageUrl(variant, staticsUrl, isBynderImagesEnabled) {
    if (isBynderImagesEnabled) {
        var ref;
        return getFrontImage((ref = variant.media) === null || ref === void 0 ? void 0 : ref.images).url;
    }
    const imageUrl = (getNestedProperty(variant, 'images', [])[0] || {}).url || '';
    return imageUrl ? `${staticsUrl}${imageUrl}` : undefined;
}

var useWasSeenByUser = ()=>{
    const _ref = useInView({
        threshold: 0.75,
        triggerOnce: true
    }), { inView  } = _ref, rest = swcHelpers.objectWithoutProperties(_ref, [
        "inView"
    ]);
    return swcHelpers.objectSpread({}, rest, {
        wasSeen: inView
    });
};

const pushPageTypeToDataLayer = (name)=>{
    const pageName = getPageType(name);
    /**
   * Since we don't use Bloomreach for the CO and MyAccount we need to prevent
   * sending this event for those pages. PageType will be send from the CO and
   * MyAccount packages
   */ if (pageName === 'pagenotfound') return;
    pushEvent({
        event: 'page_data_loaded',
        page: {
            unixTimestamp: Math.floor(Date.now() / 1000),
            type: pageName
        }
    });
};

const setUserObjectDataLayer = (isLoggedIn = false)=>{
    pushEvent({
        event: 'user_data_loaded',
        user: {
            loginStatus: isLoggedIn.toString()
        }
    });
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Actions: actions,
  DataLayerTypes: types,
  DataLayerUtils: utils,
  pushEvent: pushEvent,
  pushEcommerceEvent: pushEcommerceEvent,
  pushPageTypeToDataLayer: pushPageTypeToDataLayer,
  setUserObjectDataLayer: setUserObjectDataLayer
});

function* onPushEvent(action) {
    /**
   * We copy the payload object here so GTM doesn't mutate it by adding a "gtm.uniqueEventId" property
   * onto it. This property will be added onto every GTM event, but we don't need it added onto our action payload.
   */ yield call(pushEvent, swcHelpers.objectSpread({}, action.payload));
}
var dataLayerSagas = [
    takeLatest(pushEvent$1.type, onPushEvent)
];

function* sagas() {
    yield all([
        ...dataLayerSagas
    ]);
}

var ldJson = /*#__PURE__*/Object.freeze({
  __proto__: null
});

var ActionType;
(function(ActionType) {
    ActionType["Action"] = "Action";
    ActionType["Add"] = 'AddAction';
    ActionType["Delete"] = 'DeleteAction';
    ActionType["Reserve"] = 'ReserveAction';
    ActionType["Subscribe"] = 'SubscribeAction';
    ActionType["Search"] = 'SearchAction';
    ActionType["UnRegister"] = 'UnRegisterAction';
})(ActionType || (ActionType = {}));

const createCartAddAction$1 = (object)=>{
    const action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Add,
        name: 'add_to_cart',
        object
    };
    return action;
};
const createCartDeleteAction$1 = (object)=>{
    const action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Delete,
        name: 'remove_from_cart',
        object
    };
    return action;
};
const createUpdateQuantityAction = (updateAction)=>{
    let action;
    if (updateAction.updateType === 'increase') {
        action = createCartAddAction$1(updateAction.object);
    } else {
        action = createCartDeleteAction$1(updateAction.object);
    }
    return action;
};
/**
 * Public methods - use these outside this package
 */ /**
 * @deprecated - use the Data Layer for analytics
 */ const addToCartSdAction$1 = (productObjects)=>{
    for (const productObject of productObjects){
        const action = createCartAddAction$1(productObject);
        action && pushSdAction(action);
    }
};
/**
 * @deprecated - use the Data Layer for analytics
 */ const updateQuantitySdAction = (actions)=>{
    for (const updateAction of actions){
        const action = createUpdateQuantityAction(updateAction);
        action && pushSdAction(action);
    }
};
/**
 * @deprecated - use the Data Layer for analytics
 */ const removeLineItemsSdAction$1 = (objects)=>{
    for (const object of objects){
        const action = createCartDeleteAction$1(object);
        action && pushSdAction(action);
    }
};

var cartV2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createCartAddAction: createCartAddAction$1,
  createCartDeleteAction: createCartDeleteAction$1,
  createUpdateQuantityAction: createUpdateQuantityAction,
  addToCartSdAction: addToCartSdAction$1,
  updateQuantitySdAction: updateQuantitySdAction,
  removeLineItemsSdAction: removeLineItemsSdAction$1
});

const { isPrescriptionGlassesLineItem  } = CommerceToolsApi;
const createCartAddAction = (lineItem, formatProductUrl, quantity)=>{
    var ref, ref1;
    const object = isPrescriptionGlassesLineItem(lineItem) ? createPrescriptionGlassesObject(lineItem, formatProductUrl) : createProductObject(lineItem, quantity, formatProductUrl);
    const action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Add,
        name: 'add_to_cart',
        object
    };
    const category = (action === null || action === void 0 ? void 0 : (ref = action.object) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.toString()) || '';
    if (CommerceToolsApi.isAdditionalCartCosts(category)) {
        return undefined;
    }
    return action;
};
const createCartDeleteAction = (lineItem, formatProductUrl, quantity)=>{
    var ref, ref2;
    const object = isPrescriptionGlassesLineItem(lineItem) ? createPrescriptionGlassesObject(lineItem, formatProductUrl) : createProductObject(lineItem, quantity, formatProductUrl);
    const action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Delete,
        name: 'remove_from_cart',
        object
    };
    const category = (action === null || action === void 0 ? void 0 : (ref = action.object) === null || ref === void 0 ? void 0 : (ref2 = ref.category) === null || ref2 === void 0 ? void 0 : ref2.toString()) || '';
    if (CommerceToolsApi.isAdditionalCartCosts(category)) {
        return undefined;
    }
    return action;
};
/**
 * Public methods - use these outside this package
 */ /**
 * @deprecated - use the Data Layer for analytics
 */ const addToCartSdAction = (lineItems, formatProductUrl)=>{
    for (const lineItem of lineItems){
        const action = createCartAddAction(lineItem, formatProductUrl);
        action && pushSdAction(action);
    }
};
/**
 * @deprecated - use the Data Layer for analytics
 */ const removeLineItemsSdAction = (lineItems, formatProductUrl)=>{
    if (lineItems && lineItems.length) {
        lineItems.forEach((lineItem)=>{
            const action = createCartDeleteAction(lineItem, formatProductUrl);
            action && pushSdAction(action);
        });
    }
};

var CheckoutSteps;
(function(CheckoutSteps) {
    CheckoutSteps["Shipping"] = 'shipping';
    CheckoutSteps["Overview"] = 'overview';
    CheckoutSteps["Payment"] = 'payment';
    CheckoutSteps["Completed"] = 'completed';
})(CheckoutSteps || (CheckoutSteps = {}));
const getSdStepActionName = (currentStep)=>{
    switch(currentStep){
        case CheckoutSteps.Shipping:
            return 'order_start';
        case CheckoutSteps.Overview:
            return 'order_checkpoint_1';
        case CheckoutSteps.Payment:
            return 'order_checkpoint_2';
        case CheckoutSteps.Completed:
            return 'order_finished';
        default:
            return undefined;
    }
};
// Basic checkout action
const createCheckoutAction = (name = '')=>({
        '@context': 'https://schema.org',
        '@type': ActionType.Action,
        name
    })
;
const createCheckoutOrderAction = (order, paymentMethod, formatProductUrl, selfUrl)=>{
    const object = createOrderObject(order, paymentMethod, formatProductUrl, selfUrl);
    return {
        '@context': 'https://schema.org',
        '@type': ActionType.Action,
        name: 'order_finished',
        object
    };
};
/**
 * Public methods - use only these outside this package
 */ /**
 * @deprecated - use the Data Layer for analytics
 */ const checkoutStepSdAction = (checkoutStep)=>{
    if (typeof checkoutStep === 'string') {
        const actionName = getSdStepActionName(checkoutStep);
        if (actionName) {
            const action = createCheckoutAction(actionName);
            pushSdAction(action);
        }
    }
};
/**
 * @deprecated - use the Data Layer for analytics
 */ const checkoutCompletedSdAction = (order, paymentMethod, formatProductUrl, selfUrl)=>{
    if (order) {
        const action = createCheckoutOrderAction(order, paymentMethod, formatProductUrl, selfUrl);
        pushSdAction(action);
    }
};

const createSearchAction = (currentFacets, facetLabels, priceRange, locale)=>{
    const filterList = currentFacets.map((currentFacet)=>{
        const facetLabel = getFacetLabel(currentFacet.facet, facetLabels);
        const propertyID = currentFacet.facet;
        const selectedValues = currentFacet.value.join(';');
        return {
            '@type': 'PropertyValue',
            name: facetLabel,
            propertyID: getSanitizedFacetName(propertyID, locale),
            value: selectedValues
        };
    });
    if (priceRange && priceRange.facet && priceRange.value) {
        const prices = priceRange.value.match(/\d+/g);
        const minValue = prices && +prices[0] / 100 || 0;
        const maxValue = prices && +prices[1] / 100 || 0;
        const filter = {
            '@type': 'PropertyValue',
            name: getFacetLabel(priceRange.facet, facetLabels),
            propertyID: getSanitizedFacetName(priceRange.facet, locale),
            minValue,
            maxValue
        };
        filterList.push(filter);
    }
    return {
        '@context': 'https://schema.org',
        '@type': ActionType.Search,
        name: 'search',
        object: {
            '@type': 'ItemList',
            name: 'filters',
            itemListElement: filterList
        }
    };
};
/**
 * Public methods - use these outside this package
 */ /**
 * @deprecated - use the Data Layer for analytics
 */ const searchSdAction = (currentFacets, facetLabels, priceRange, locale)=>{
    const action = createSearchAction(currentFacets, facetLabels, priceRange, locale);
    pushSdAction(action);
};

/**
 * @deprecated - use the Data Layer for analytics
 */ const setUserObject = (isLoggedIn = false)=>{
    if (typeof window === 'undefined') {
        return;
    }
    // Create empty user object if it not yet exists
    if (!window.grandvision || !window.grandvision.user) {
        window.grandvision = {
            user: {}
        };
    }
    window.grandvision.user = {
        loggedIn: isLoggedIn
    };
};

const createServiceObject = (serviceType = 'WebPage', audience, category, brand)=>swcHelpers.objectSpread({
        '@context': 'https://schema.org',
        '@type': 'Service',
        serviceType
    }, audience && {
        audience
    }, category && {
        category
    }, brand && {
        brand
    })
;
/*
 * Sets the global grandvision.service object.
 * For analytics purposes, be sure to use English values only.
 * Audience, category and brand may be supplied when relevant.
 * */ /**
 * @deprecated - use the Data Layer for analytics
 */ const setServiceObject = (serviceType, audience, category, brand)=>{
    if (typeof window === 'undefined') {
        return;
    }
    if (!window.grandvision) {
        window.grandvision = {};
    }
    window.grandvision.service = createServiceObject(serviceType, audience, category, brand);
};

const JsonLd = (thing)=>/*#__PURE__*/ React.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(swcHelpers.objectSpread({
                '@context': 'http://schema.org'
            }, thing), null, 2)
        }
    })
;

const BreadcrumbList = ({ breadcrumbs  })=>{
    const breadcrumbsList = breadcrumbs.map((crumb, index)=>{
        const crumbImage = {
            image: crumb.image
        };
        return {
            '@type': 'ListItem',
            position: index + 1,
            item: swcHelpers.objectSpread({
                '@id': crumb.url,
                name: crumb.name
            }, crumbImage)
        };
    });
    if (breadcrumbsList.length < 1) {
        return null;
    }
    const payload = {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
            ...breadcrumbsList
        ]
    };
    return /*#__PURE__*/ React.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(payload)
        }
    });
};

const initGA = (trackerID, options)=>{
    const { analyticsId  } = QueryString.parse(window.location.search.substring(1));
    const GAOptions = swcHelpers.objectSpread({}, options, analyticsId ? {
        gaOptions: {
            clientId: StringGuard.guard('analyticsId', analyticsId)
        }
    } : {});
    ReactGA.initialize(trackerID, GAOptions);
};
const logError = (scope, message)=>{
    console.error(`[${scope}] ${message}`);
};
/**
 * when using adblocking the callback will never be hit. Creating an order will be then blocked.
 * Check if google tag manager is loaded else resolve.
 */ const getAnalyticsId = ()=>{
    return new Promise((resolve)=>{
        const { ga  } = window;
        let timeoutFlag = false;
        const gaTimeout = setTimeout(()=>{
            logError('getAnalyticsId', 'ReactGa not loaded. Hit timeout.');
            timeoutFlag = true;
            resolve();
        }, 200);
        ReactGA.ga((tracker)=>{
            if (timeoutFlag) {
                return;
            }
            clearTimeout(gaTimeout);
            if (!tracker) {
                logError('getAnalyticsId', 'Analytics not initialized');
                resolve();
            }
            const clientId = tracker.get('clientId');
            if (clientId) {
                resolve(clientId);
            } else {
                logError('getAnalyticsId', 'No client id received from ReactGA tracker.');
                resolve();
            }
        });
        if (!ga || !ga.loaded) {
            clearTimeout(gaTimeout);
            logError('getAnalyticsId', 'ReactGa not loaded.');
            resolve();
        }
    });
};
const logPageView = (pathName)=>{
    if (pathName) {
        ReactGA.set({
            page: pathName
        });
        ReactGA.pageview(pathName);
    } else {
        let location = window.location.pathname;
        const href = window.location.href.split('?')[1];
        if (href) {
            location = location + '?' + href;
        }
        ReactGA.set({
            page: location
        });
        ReactGA.pageview(location);
    }
};
const GoogleAnalytics = {
    initGA,
    getAnalyticsId,
    logPageView
};

const GoogleTagManager = ({ gtmId , placement  })=>{
    const tags = (Array.isArray(gtmId) ? gtmId : [
        gtmId
    ]).map((id)=>gtmParts({
            id
        })
    );
    if (placement === 'head') {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("link", {
            rel: "preconnect",
            href: "https://www.googletagmanager.com"
        }), /*#__PURE__*/ React.createElement("link", {
            rel: "preconnect",
            href: "https://www.google-analytics.com"
        }), tags.map((tag, i)=>/*#__PURE__*/ React.createElement(React.Fragment, {
                key: i
            }, tag.scriptAsReact())
        ));
    } else if (placement === 'body') {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, tags.map((tag, i)=>/*#__PURE__*/ React.createElement(React.Fragment, {
                key: i
            }, tag.noScriptAsReact())
        ));
    } else {
        return null;
    }
};

const Organization = (props)=>{
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, props));
};

const Product = ({ product , activeSKU , staticsUrl , url , locale ='en' , extra  })=>{
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const activeVariant = [
        product.masterVariant,
        ...product.variants
    ].find((variant)=>variant.sku === activeSKU
    ) || product.masterVariant;
    const includedVatAmount = getIncludedVatAmount(product);
    const offers = [
        {
            '@type': 'Offer',
            priceSpecification: createPriceSpecification(activeVariant, includedVatAmount)
        }, 
    ];
    const { name , image , description , brand , category , sku  } = parseProductData(product, activeVariant, staticsUrl, locale, isBynderImagesEnabled);
    const aggregateRating = product.ratingsSummary ? {
        '@type': 'AggregateRating',
        ratingValue: product.ratingsSummary.average,
        reviewCount: product.ratingsSummary.reviewCount
    } : {};
    const payload = swcHelpers.objectSpread({
        '@type': 'Product',
        '@id': `${url}#product`,
        url,
        sku,
        image,
        name: name && String(name) || sku
    }, optionalKey('description', description), optionalKey('brand', brand), optionalKey('category', category), optionalKey('offers', offers), optionalKey('aggregateRating', aggregateRating), extra);
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, payload));
};

var Offer = (_param)=>{
    var rest = swcHelpers.extends({}, _param);
    const payload = swcHelpers.objectSpread({
        '@type': 'Offer'
    }, rest);
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, payload));
};

// For now we are using the masterVariant
const ProductsSd = ({ items , formatProductUrl , staticsUrl , locale , originUrl  })=>{
    const productList = items.map((product, index)=>{
        const sku = product.masterVariant.sku;
        const productType = product && product.productType && product.productType.obj ? product.productType.obj.name : '';
        const slug = product.slug;
        const productUrl = `${originUrl || ''}${formatProductUrl({
            productType,
            sku,
            slug
        })}`;
        const activeVariant = product.masterVariant;
        const { name , description , brand , category  } = parseProductData(product, activeVariant, staticsUrl, locale);
        const includedVatAmount = getIncludedVatAmount(product);
        const offers = [
            {
                '@type': 'Offer',
                priceSpecification: createPriceSpecification(activeVariant, includedVatAmount)
            }, 
        ];
        const aggregateRating = product.ratingsSummary ? {
            '@type': 'AggregateRating',
            ratingValue: product.ratingsSummary.average,
            reviewCount: product.ratingsSummary.reviewCount
        } : {};
        const listItemContent = swcHelpers.objectSpread({
            '@type': 'Product',
            '@id': `${productUrl}#product`,
            name: name && String(name) || sku,
            url: productUrl
        }, optionalKey('description', description), optionalKey('brand', brand), optionalKey('category', category), optionalKey('offers', offers), optionalKey('aggregateRating', aggregateRating), {
            sku
        });
        return {
            '@type': 'ListItem',
            position: index + 1,
            item: listItemContent
        };
    });
    const payload = {
        '@type': 'ItemList',
        itemListElement: productList
    };
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, payload));
};

var OpenClosedStatus;
(function(OpenClosedStatus) {
    OpenClosedStatus["Open"] = 'OPEN';
    OpenClosedStatus["Closing"] = 'CLOSING';
    OpenClosedStatus["Closed"] = 'CLOSED';
})(OpenClosedStatus || (OpenClosedStatus = {}));
const Store = ({ store , url  })=>{
    const features = useFeatureToggles();
    const cleanUrl = url.split('?')[0];
    const { rating  } = store;
    const payload = {
        '@type': 'Store',
        '@id': `${cleanUrl}/${store.town.toLocaleLowerCase()}/${store.slug}#store`,
        url: `${cleanUrl}/${store.town.toLocaleLowerCase()}/${store.slug}`,
        name: store.storeName,
        description: store.metaDescription,
        email: store.storeEmailAddress,
        telephone: store.Phone1,
        image: store.detailImage,
        address: [
            {
                '@type': 'PostalAddress',
                streetAddress: `${store.streetName} ${store.streetNumber}`,
                postalCode: store.postalCode,
                addressLocality: store.town,
                addressCountry: store.country
            }, 
        ],
        contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'sales contact point',
            telephone: store.Phone1
        },
        openingHoursSpecification: getOpeningHoursSpecification(store),
        hasOfferCatalog: store.facilities ? getServices(store.facilities) : undefined,
        aggregateRating: features.isStoreRatingsEnabled && rating ? {
            '@type': 'AggregateRating',
            bestRating: 5,
            worstRating: 1,
            ratingValue: rating.value,
            ratingCount: rating.count
        } : undefined
    };
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, payload));
};

const Stores = ({ stores , url  })=>{
    const cleanUrl = url.split('?')[0];
    const storeList = stores.map((store, index)=>({
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@type': 'Store',
                '@id': `${cleanUrl}/${store.slug}#store`,
                // TODO: replace as soon as we have a detail page URL available
                url: `${cleanUrl}/${store.slug}`,
                name: store.storeName,
                email: store.storeEmailAddress,
                image: store.storeDetailImage,
                address: [
                    {
                        '@type': 'PostalAddress',
                        streetAddress: `${store.streetName} ${store.streetNumber}`,
                        postalCode: store.postalCode,
                        addressLocality: store.town,
                        addressCountry: store.country
                    }, 
                ],
                contactPoint: {
                    '@type': 'ContactPoint',
                    contactType: 'sales contact point',
                    telephone: store.Phone1
                },
                openingHours: getOpeningHours(store)
            }
        })
    );
    const payload = {
        '@type': 'ItemList',
        itemListElement: storeList
    };
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, payload));
};

var WebPage = (_param)=>{
    var { pageType , url  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "pageType",
        "url"
    ]);
    const cleanUrl = url === null || url === void 0 ? void 0 : url.split('?')[0];
    if (!cleanUrl) {
        return null;
    }
    const payload = swcHelpers.objectSpread({
        '@type': 'WebPage',
        '@id': cleanUrl
    }, pageType ? {
        additionalType: `https://grandvision.com/#/PageType/${pageType}`
    } : {}, rest, {
        url: cleanUrl
    });
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, payload));
};

const ALGOLIA_ANALYTICS_STORAGE_KEY = 'algoliaAnalyticsData';
const useAlgoliaAnalytics = ()=>{
    const [data1, setData] = useLocalStorage(ALGOLIA_ANALYTICS_STORAGE_KEY, {
        queryId: undefined,
        searchIndex: ''
    });
    const saveData = React__default.useCallback((newData)=>{
        setData(newData);
    }, []);
    const clearQueryId = React__default.useCallback(()=>{
        setData((data = {})=>swcHelpers.objectSpread({}, data, {
                queryId: undefined
            })
        );
    }, [
        data1
    ]);
    const handleConversionEvent$1 = React__default.useCallback((objectId, queryId)=>{
        if (data1) {
            handleConversionEvent({
                objectIds: objectId,
                searchIndex: data1.searchIndex,
                queryId
            });
        }
    }, [
        data1
    ]);
    return {
        algoliaAnalyticsData: data1,
        saveData,
        clearQueryId,
        handleConversionEvent: handleConversionEvent$1
    };
};

const AlgoliaAnalytics = ({ children , searchResults  })=>{
    if (!children) {
        return null;
    }
    const { saveData  } = useAlgoliaAnalytics();
    const { queryID , index  } = searchResults;
    const handleSearchAnalytics = (objectId, position, eventName)=>()=>{
            const eventData = {
                eventName: eventName || AlgoliaAnalyticsEvents.SearchResultClicked,
                objectIds: objectId,
                searchIndex: index
            };
            if (queryID && position) {
                saveData({
                    queryId: queryID,
                    searchIndex: index
                });
                clickedObjectIdsAfterSearch(swcHelpers.objectSpread({}, eventData, {
                    queryId: queryID,
                    positions: position
                }));
            } else {
                clickedObjectIds(eventData);
            }
        }
    ;
    return children(handleSearchAnalytics);
};
var AlgoliaAnalytics$1 = connectStateResults(AlgoliaAnalytics);

// You may be tempted to render this component in something like Next.js Head,
// but that will break accessing the cookie consent context, due to the magic that
// goes on in inside the Head component. The result of that magic is that the context will always return null.
// As a workaround we are passing in the Next.js Head and Next.js Script components
// and we still have the scripts and links in the html <head> tag where we need them.
const Optimizely = ({ projectId , HeadComponent , ScriptComponent  })=>{
    const consentResult = useCookieConsentContext();
    // If we don't have HeadComponent and ScriptComponent continue rendering as is.
    // @TODO remove this later, since this component should never be rendered without
    // functional consent.
    if (!isCookieCategoryEnabled('functional', consentResult) && HeadComponent && ScriptComponent) {
        return null;
    }
    if (!projectId) {
        console.error('No project ID for Optimizely found');
        return null;
    }
    const HeadWrapper = HeadComponent ? HeadComponent : React__default.Fragment;
    const optimizelySrc = `https://cdn.optimizely.com/js/${projectId}.js`;
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(HeadWrapper, null, /*#__PURE__*/ React__default.createElement("link", {
        rel: "preconnect",
        href: "https://cdn.optimizely.com"
    }), /*#__PURE__*/ React__default.createElement("link", {
        rel: "preconnect",
        href: "https://logx.optimizely.com"
    })), ScriptComponent ? /*#__PURE__*/ React__default.createElement(ScriptComponent, {
        src: optimizelySrc,
        strategy: "afterInteractive"
    }) : /*#__PURE__*/ React__default.createElement("script", {
        src: optimizelySrc
    }));
};

SagaRegistry.register('analytics', sagas);

export { ALGOLIA_ANALYTICS_STORAGE_KEY, ActionType, AlgoliaAnalytics$1 as AlgoliaAnalytics, AlgoliaAnalyticsHelpers, types$1 as AlgoliaAnalyticsTypes, BreadcrumbList, cartV2 as CartV2Actions, CheckoutSteps, index as DataLayer, GoogleAnalytics, GoogleTagManager, JsonLd, Offer, Optimizely, Organization, Product, ProductsSd, Store, Stores, ldJson as StructuredDataTypes, WebPage, addToCartSdAction, calcPrice, checkoutCompletedSdAction, checkoutStepSdAction, createCartAddAction, createCartDeleteAction, createCheckoutAction, createCheckoutOrderAction, createOfferObject, createOrderObject, createPrescriptionGlassesObject, createPrescriptionGlassesOffer, createPrescriptionGlassesPrice, createPriceSpecification, createProductObject, createSearchAction, getFacetLabel, getIncludedVatAmount, getPaymentMethodUrl, getSanitizedFacetName, getSdStepActionName, getUrlInfo, parseProductData, priceVatCalc, pushSdAction, removeLineItemsSdAction, searchSdAction, setServiceObject, setUserObject, useAlgoliaAnalytics, useWasSeenByUser };
//# sourceMappingURL=index.js.map
